import React, { useState } from 'react';
import './Fruits.css';

// Import images for fruits
import appleImage from './images/apple.jpg';
import bananaImage from './images/banana.jpg';
import orangeImage from './images/orange.jpg';
import grapesImage from './images/grapes.jpg';
import mangoImage from './images/mango.jpg';
import pineappleImage from './images/pineapple.jpg';
import strawberryImage from './images/strawberry.jpg';
import blueberryImage from './images/blueberry.jpg';
import watermelonImage from './images/watermelon.jpg';
import kiwiImage from './images/Kiwi.jpg';

import papayaImage from './images/papaya.jpg';
import JackfruitImage from './images/Jackfruit.jpg';
import GuavaImage from './images/Guava.jpg';
import peachImage from './images/Peach.jpg';
import CustardAppleImage from './images/CustardApple.jpg';
import promogranateImage from './images/promogranate.png';


const fruits = [
  { name: 'Apple', image: appleImage },
  { name: 'Banana', image: bananaImage },
  { name: 'Orange', image: orangeImage },
  { name: 'Grapes', image: grapesImage },
  { name: 'Mango', image: mangoImage },
  { name: 'Pineapple', image: pineappleImage },
  { name: 'Strawberry', image: strawberryImage },
  { name: 'Blueberry', image: blueberryImage },
  { name: 'Watermelon', image: watermelonImage },
  { name: 'Kiwi', image: kiwiImage },

  { name: 'Papaya', image: papayaImage },
  { name: 'Jackfruit', image: JackfruitImage },
  { name: 'Guava', image: GuavaImage },
  { name: 'Peach fruit', image: peachImage },
  { name: 'Custard Apple', image: CustardAppleImage },
  { name: 'Promogranate', image: promogranateImage }
];

const Fruits = () => {
  const [selectedFruit, setSelectedFruit] = useState(null);
  const [quizFruit, setQuizFruit] = useState(null);
  const [quizAnswer, setQuizAnswer] = useState('');
  const [quizResult, setQuizResult] = useState('');

  const speakFruit = (fruitName) => {
    const utterance = new SpeechSynthesisUtterance(fruitName);
    window.speechSynthesis.speak(utterance);
  };

  const handleFruitClick = (fruit) => {
    setSelectedFruit(fruit);
    speakFruit(fruit.name);
  };

  const startQuiz = () => {
    const randomFruit = fruits[Math.floor(Math.random() * fruits.length)];
    setQuizFruit(randomFruit);
    setQuizAnswer('');
    setQuizResult('');
  };

  const submitQuiz = () => {
    if (quizAnswer.toLowerCase() === quizFruit.name.toLowerCase()) {
      setQuizResult('Correct!');
    } else {
      setQuizResult(`Wrong! The correct fruit was ${quizFruit.name}`);
    }
  };

  const clearQuiz = () => {
    setQuizFruit(null);
    setQuizAnswer('');
    setQuizResult('');
  };

  const nextQuiz = () => {
    startQuiz();
  };

  return (
    <div className="AppFruits">
      <h1>Learn Fruits</h1>
      <div className="fruits">
        {fruits.map((fruit) => (
          <div
            key={fruit.name}
            className="fruit-box"
            onClick={() => handleFruitClick(fruit)}
          >
            <img src={fruit.image} alt={fruit.name} className="fruit-image" />
            <p>{fruit.name}</p>
          </div>
        ))}
      </div>
      {selectedFruit && <div className="selected-fruit">You selected: {selectedFruit.name}</div>}
      <div className="quiz-section">
        <h2>Quiz Mode</h2>
        {quizFruit ? (
          <div>
            <p>What fruit is this?</p>
            <img src={quizFruit.image} alt="Quiz Fruit" className="quiz-image" />
            <input
              type="text"
              value={quizAnswer}
              onChange={(e) => setQuizAnswer(e.target.value)}
              placeholder="Enter fruit name"
            />
            <button onClick={submitQuiz}>Submit</button>
            <button onClick={nextQuiz}>Next Fruit</button>
            <button onClick={clearQuiz}>Clear</button>
            {quizResult && <p>{quizResult}</p>}
          </div>
        ) : (
          <button onClick={startQuiz}>Start Quiz</button>
        )}
      </div>
    </div>
  );
};

export default Fruits;



